<template>
  <ElForm
    ref="editPriceOfferForm"
    :model="formModel"
    :rules="formRules"
    class="edit-price-offer-form"
    @submit="save"
  >
    <ElFormItem prop="type">
      <ElRadio v-model="formModel.type" label="absolute">
        مقدار مشخص
      </ElRadio>
    </ElFormItem>
    <ElCollapseTransition>
      <div v-show="formModel.type === 'absolute'" class="row">
        <div class="columns">
          <ElFormItem prop="value">
            <ElInput
              v-model.number="formModel.value"
              :placeholder="$t('ADVERTISEMENT.BID.MAX_CPI')"
              type="number"
              size="mini"
            />
          </ElFormItem>
        </div>
      </div>
    </ElCollapseTransition>

    <ElFormItem prop="type">
      <ElRadio v-model="formModel.type" label="increase">
        اضافه کردن
      </ElRadio>
    </ElFormItem>
    <ElCollapseTransition>
      <div v-show="formModel.type === 'increase'" class="row">
        <div class="columns large-6 medium-6 small-12">
          <ElFormItem prop="valuetype">
            <AlternativeSelect
              v-model="formModel.valueType"
              :items="valueTypeItems"
              size="mini"
            />
          </ElFormItem>
        </div>
        <div class="columns large-6 medium-6 small-12">
          <ElFormItem prop="value">
            <ElInput
              v-model.number="formModel.value"
              type="number"
              size="mini"
              placeholder="عددی وارد کنید"
            >
              <template slot="append">
                {{ valueTypeSymbol }}
              </template>
            </ElInput>
          </ElFormItem>
        </div>
      </div>
    </ElCollapseTransition>

    <ElFormItem prop="type">
      <ElRadio v-model="formModel.type" label="decrease">
        کم کردن
      </ElRadio>
    </ElFormItem>
    <ElCollapseTransition>
      <div v-show="formModel.type === 'decrease'" class="row">
        <div class="columns large-6 medium-6 small-12">
          <ElFormItem prop="valuetype">
            <AlternativeSelect
              v-model="formModel.valueType"
              :items="valueTypeItems"
              size="mini"
            />
          </ElFormItem>
        </div>
        <div class="columns large-6 medium-6 small-12">
          <ElFormItem prop="value">
            <ElInput
              v-model.number="formModel.value"
              placeholder="عددی وارد کنید"
              type="number"
              size="mini"
            >
              <template slot="append">
                {{ valueTypeSymbol }}
              </template>
            </ElInput>
          </ElFormItem>
        </div>
      </div>
    </ElCollapseTransition>
    <ElFormItem class="edit-price-offer-form__actions">
      <StrokeButton
        :loading="loading"
        size="small"
        type="primary"
        @click="save"
      >
        {{ $t('SAVE') }}
      </StrokeButton>
      <ElButton size="small" type="text" @click="$emit('cancel')">
        {{ $t('CANCEL') }}
      </ElButton>
    </ElFormItem>
  </ElForm>
</template>

<script>
import required from '@/utils/validation-rules/required';

import AlternativeSelect from '@@/common/AlternativeSelect';
import StrokeButton from '@@/advertisement/common/StrokeButton';

import form from '@/mixins/form';

export default {
  name: 'EditPriceOfferForm',
  components: {
    AlternativeSelect,
    StrokeButton,
  },
  mixins: [form],
  props: {
    resetController: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        type: 'absolute',
        value: null,
        valueType: 'amount',
      },
    };
  },
  computed: {
    valueTypeSymbol() {
      return this.formModel.valueType === 'amount' ? 'ریال' : '%';
    },
    valueTypeItems() {
      return [
        {
          label: 'مقدار',
          value: 'amount',
        },
        {
          label: 'درصد',
          value: 'percent',
        },
      ];
    },
    formRules() {
      return {
        value: [
          required(this.$t('VALIDATION_REQUIRED_ERR')),
          {
            validator: this.validateValue,
            type: 'number',
            trigger: 'blur',
          },
        ],
      };
    },
  },
  watch: {
    'formModel.type'() {
      this.resetValue();
    },
    'formModel.valueType'() {
      this.resetValue();
    },
  },
  created() {
    this.resetController.onReset(this.reset);
  },
  beforeDestroy() {
    this.resetController.removeOnReset(this.reset);
  },
  methods: {
    resetValue() {
      this.formModel.value = null;

      this.clearValidate();
    },
    validateValue(rule, value, cb) {
      if (
        this.formModel.valueType === 'percent' &&
        (value > 100 || value < 0)
      ) {
        cb(new Error('Percent error'));
        return;
      } else if (value < 0) {
        cb(new Error(this.$t('VALIDATION_NO_ZERO')));
      }
      cb();
    },
    cancel() {
      this.$emit('cancel');
    },
    save() {
      if (this.isValid) this.$emit('save', this.formModel);
    },
    clearValidate() {
      this.$refs.editPriceOfferForm.clearValidate();
    },
    reset() {
      this.resetForm('editPriceOfferForm');
    },
  },
};
</script>

<style lang="scss">
.edit-price-offer-form {
  &__actions {
    margin-bottom: calc($global-margin / 4);
    direction: rtl;
    @include rtl() {
      direction: ltr;

      .el-button + .el-button {
        margin-left: calc($global-margin / 2);
        margin-right: 0;
      }
    }

    .el-button + .el-button {
      margin-right: calc($global-margin / 2);
      margin-left: 0;
    }
  }
}
</style>
